// extracted by mini-css-extract-plugin
export default {"table":"Commontable_table__XzBC6","no_record_box":"Commontable_no_record_box__AbQfN"};